(function() { module.exports = this["moment"]; }());


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 4
// module chunks = 0 1